import ExpensesManager from '../features/accounting/ExpensesManager';

export default function ExpensesPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Giderler</h1>
          <p>Restoran giderlerini kaydedin ve dönem bazında takip edin.</p>
        </div>
      </header>
      <section className="page-section">
        <ExpensesManager />
      </section>
    </div>
  );
}
